import React, { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import SuperAdminHeader from "./components/header/SuperAdminHeader";
import SuperAdminSidebar from "./components/sidebar/SuperAdminSidebar";
import { ClientStatusProvider } from "../../views/context/clientContext";
import { HeaderSlotProvider } from "../../contexts/HeaderSlotContext";

const CANVAS_BG =
  "radial-gradient(ellipse 711px 1111px at 100% 25%, rgba(76, 53, 215, 0.4) 0%, rgba(233, 240, 254, 0) 70%), #E9F0FE";

const CANVAS_STYLE = {
  background: CANVAS_BG,
  backdropFilter: "blur(90px)",
  WebkitBackdropFilter: "blur(90px)",
};

export default function SuperAdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const handleOpenSidebar = useCallback(() => {
    setSidebarOpen(true);
  }, []);

  return (
    <ClientStatusProvider>
      <HeaderSlotProvider>
        <div className="flex h-screen w-full overflow-hidden" style={CANVAS_STYLE}>
          {/* Sidebar */}
          <SuperAdminSidebar
            open={sidebarOpen}
            onClose={handleCloseSidebar}
          />

          {/* Main Section */}
          <div className="flex flex-col flex-1 h-[100%] min-w-0 overflow-hidden relative">
            {/* Header */}
            <SuperAdminHeader onOpenSidenav={handleOpenSidebar} />

            {/* Page Content */}
            <main className="flex-1 min-h-0 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="w-full px-5 pb-5 pt-3 min-h-full flex flex-col">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </HeaderSlotProvider>
    </ClientStatusProvider>
  );
}
